// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvasesResult = objectOf({
  source_canvases: arrayOf(
    objectOf({
      id: string,
      name: string,
      enabled: boolean,
      is_draft: boolean,
    })
  ),
});
